(() => {
  const blocks = document.querySelectorAll('[data-cb-desc][data-cb-enabled="1"]');
  if (!blocks.length) return;

  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

  for (const block of blocks) {
    const btn = block.querySelector('[data-cb-toggle]');
    const content = block.querySelector('[data-cb-content]');
    if (!btn || !content) continue;

    const setState = (expanded) => {
      block.classList.toggle('is-expanded', expanded);
      block.classList.toggle('is-collapsed', !expanded);
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    };

    // If not mobile, always expanded (no accidental clamp on desktop)
    const syncForBreakpoint = () => {
      if (!isMobile()) {
        setState(true);
      } else {
        // Keep initial state from markup
        const expanded = block.classList.contains('is-expanded');
        setState(expanded);
      }
    };

    btn.addEventListener(
      'click',
      () => {
        const expanded = block.classList.contains('is-expanded');
        setState(!expanded);
      },
      { passive: true }
    );

    syncForBreakpoint();
    window.addEventListener('resize', syncForBreakpoint, { passive: true });
  }
})();